<template>

<div class="side-preview animated slideInRight faster" v-if="previewPane.show">
	
    <div class="side-preview-head" v-if="preview">

		<button type="button" class="btn btn-close close" @click="close()" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>

        <div class="car-title">
            <div class="brand" v-if="preview.model.brand.logo" :style="{backgroundImage:`url(${API_URL+preview.model.brand.logo.urlThumb})`}"></div>
            <div class="title">
                <p class="m-0">{{ preview.model.brand.title }}</p>
                <h2>{{preview.model.title}}</h2>
                <p class="m-0"><small>{{preview.model_particular}} - {{preview.color.title}}</small></p>
            </div>
        </div>

	</div>

	<div class="side-preview-content" v-if="preview">
		
		<div class="pill">

			<div class="data">
                <h6 class="mt-2">VEHÍCULO</h6>
				<table class="table table-borderless table-sm ">
					<tr>
						<td >Chasis</td> <td>{{preview.chassis_number}}</td>
					</tr>
					<tr>
						<td >Motor</td> <td>{{preview.motor_number}}</td>
					</tr>
				</table>
                
                <h6 class="mt-3">DUA</h6>
				<table class="table table-borderless table-sm ">
					<tr>
						<td >DUA Tránsito</td> <td>{{preview.dua_transit}}</td>
					</tr>
					<tr>
						<td >Stock</td> <td>{{preview.dua_stock}}</td>
					</tr>
					<tr v-if="preview.dua_dispatch">
						<td ><strong>DUA Despacho</strong></td> <td><strong>{{preview.dua_dispatch}}</strong></td>
					</tr>
				</table>
                
				<!-- <div v-if="preview.delivered_by_mat">
					<h6 class="mt-3">INGRESO</h6>
					<table class="table table-borderless table-sm ">
						<tr>
							<td >Matricula</td> <td>{{preview.delivered_by_mat}}</td>
						</tr>
						<tr>
							<td >Conductor</td> <td>{{preview.delivered_by_driver_name}}</td>
						</tr>
						<tr>
							<td >Firma</td>
							<td >
								<img :src="preview.delivered_by_driver_signature" class="img-fluid">
							</td>
						</tr>
						
					</table>
				</div> -->
                
				<h6 class="mt-3">ESTADO</h6>
				<table class="table table-borderless table-sm ">
					<tr>
						<td ><div class="car-status-point" :class="preview.status"></div>{{preview.statusText}}</td>
					</tr>
				</table>
			</div>
		</div>
		
		<div class="p-3">
			<div class="alert alert-warning" v-if="preview.status=='DELIVERY_SCHEDULED' && preview.delivery_scheduled_at">
				<i class="fa fa-clock-o"></i> Entrega programada para el día {{preview.delivery_scheduled_at | moment("dddd DD [de] MMMM, YYYY")}}
			</div>
			
			<div class="alert alert-success" v-if="preview.status=='DELIVERED' && preview.delivered_at">
				<i class="fa fa-clock-o"></i> Entregado el día {{preview.delivered_at | moment("dddd DD [de] MMMM, YYYY")}}
			</div>
		</div>

		
        <div class="pill">

			<div class="data">
                <h6 class="mt-2">ACTIVIDAD</h6>
				<CarActivity :activity="preview.logs"></CarActivity>
			</div>
		</div>

	</div>

</div>
</template>
	
<script>

import gql from 'graphql-tag'
import CarActivity from '@/views/cars/CarActivity'

export default {
	name: 'CarPreview',
    props:['id'],
    components:{
		CarActivity,
    },
	data () {
		return {
            API_URL: process.env.VUE_APP_API_URL,
			previewPane:{
				show: false,
			},
			preview: {},
			// tabActive: 'info'
		}
	},
	methods:{
		open(id){
			this.preview = {}
			this.previewPane = {
				show: false,
			}
			this.load(id)
		},
		load(id){
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					car(id: $id) {
						id
						client{
                            name
                            business_name
                        }
                        model{
                            title
                            brand{
                                title
                                logo{
                                    urlThumb
                                }
                            }
                        }
                        dua_transit
                        dua_stock
                        dua_dispatch
                        motor_number
                        chassis_number
                        model_particular
                        color{
                            title
                        }
                        status
						statusText
						joined_at
						delivery_scheduled_at
						delivered_at
						logs{
							title
							description
							type
							created_at
						}
					}
				}`,
				variables: {
					id: id,
				},
			})
			.then((data) => {
				this.preview = data.data.car;
				this.previewPane.show = true;
			});
		},
		close(){
			this.previewPane.show = false;
			this.preview = {};
		},
		openRequestDelivery(){
			this.$refs.requestDelivery.open()
		}

	}
}


</script>

<style scoped lang="scss">
.car-title{
    display:flex;
    align-items: center;
    text-align: left;

    .brand{
        width:64px;
        height: 64px;
        border-radius: 100%;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        background-color:#fff;
        margin-right: 8px;
        border: solid #fff 3px;
    }
}

</style>
